module.exports = __webpack_public_path__ + "img/emailbanner.9a786680.png";